export const LIST_GALLERY = `homepage/list-gallery`;
